import { useRouteError } from 'react-router-dom';
import { ErrorScreen } from '@/components/organisms/AppErrorBoundary';

/**
 * `errorElement` raíz del router. React Router captura los errores de render de
 * las rutas con su propio boundary (no llega al `AppErrorBoundary` global), así
 * que aquí mostramos la misma pantalla de error con la marca en vez del
 * "Unexpected Application Error!" por defecto.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();
  console.error('Route render error captured by RouteErrorBoundary:', error);
  return <ErrorScreen />;
}

export default RouteErrorBoundary;
